import { Container } from "@mui/material";
import React from "react";
import DashboardDesktopMenu from "./component/DesktopMenu";

const NavBar = (props) => {
  const menuList = [
    // You can pass 4 perameters for menu title, link, target and customClass
    // {
    //   title: "Home",
    //   link: "#home",
    // },
    // {
    //   title: "Stats",
    //   link: "#stats",
    // },
    // {
    //   title: "How It Works",
    //   link: "#howitwork",
    // },
    // {
    //   title: "SVAULT Token",
    //   link: "#tokenomics",
    // },
    // {
    //   title: "Documents",
    //   link: "#document",
    // },
    // {
    //   title: "FAQ",
    //   link: "#faq",
    // },
  ];
  return (
    <Container>
      <DashboardDesktopMenu menuList={menuList} />
      {/* <MobileMenu menuList={menuList} /> */}
    </Container>
  );
};

export default NavBar;
